<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <i class="fa fa-globe"></i> {{ $t('statistic.traffic') }}
                    <!--<div class="card-actions">-->
                    <!--<a class="btn-minimize" @click="toggleChart"><i class="icon-eye"></i></a>-->
                    <!--</div>-->
                </div>
                <div class="card-block">
                    <div id="dash-chart-traffic"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Highcharts from 'highcharts'
  import { find, map, cloneDeep } from 'lodash'
  import Storage from '../api/Storage'
  import CountryColor from '../assets/CountryColor'
  import Exporting from 'highcharts/modules/exporting'
  import API from '../api/API'

Exporting(Highcharts)

  let chartOptions = {
    isBuilded: false,
    isHidden: false,
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      align: 'right',
      verticalAlign: 'top',
      layout: 'vertical',
      x: 0,
      y: 30
    },
    plotOptions: {
      line: {
        events: {
          legendItemClick: function () {
            if (this.userOptions.visible) {
              API.disabledDasbourdCountry(this.userOptions.id)
            } else {
              API.enabledDashboardCountry(this.userOptions.id)
            }
          }
        }
      }
    },
    yAxis: [{ // --- Primary yAxis
      title: {
        text: null
      }
    }],
    xAxis: {
      categories: []
    },
    exporting: {
      allowHTML: true,
      buttons: {
        contextButton: {
          enabled: false
        },
        hideButton: {
          text: '<span style="font-family: FontAwesome; font-size: 14px">\uf070</span>',
          x: -80,
          onclick: function (e) {
            if (typeof this.isHidden !== 'undefined') {
              this.isHidden = !this.isHidden
            } else {
              this.isHidden = false
            }
            this.series.map((v, i) => {
              this.isHidden ? this.series[i].show() : this.series[i].hide()
            })
          }
        }
      }
    },
    series: []
  }
  export default {
    props: {
      chartData: {
        type: Object,
        required: true
      }
    },
    mounted: function () {
      if (!chartOptions.isBuilded) {
        chartOptions.yAxis[0].title.text = this.$t('statistic.traffic')
        chartOptions.xAxis.categories = this.chartData.dates ? this.chartData.dates : []
        map(this.chartData.values, (dataItem, dataIndex) => {
          const country = find(Storage.countries, {id: parseInt(dataIndex, 10)})
          chartOptions.series.push({
            id: country.id,
            name: this.$t('country.' + country.id),
            color: CountryColor[country.id],
            data: cloneDeep(dataItem),
            visible: true
          })
        })
        chartOptions.isBuilded = true
      } else {
        this.chart = Highcharts.chart('dash-chart-traffic', chartOptions)
      }
      API.getDisabledCountry().then(response => {
        response.body.forEach(item => {
          for (let i in chartOptions.series) {
            if (chartOptions.series[i].id === item && item) {
              chartOptions.series[i].visible = false
            }
          }
        })
        this.chart = Highcharts.chart('dash-chart-traffic', chartOptions)
      })
    },
    data () {
      return {
        chartOptions: chartOptions,
        chart: null
      }
    },
    name: 'TrafficChart'
  }
</script>



// WEBPACK FOOTER //
// TrafficChart.vue?01cd0346